import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function initGallery() {

	const galleries = document.querySelectorAll('.gallery');

	galleries.forEach(el => {
		const slider = el.querySelector('.swiper');

		const swiper = new Swiper(slider, {
			modules: [Navigation, Pagination],
	    slidesPerView: 1,
	    simulateTouch: false,
	    speed: 600,
	    loop: true,
	    // pagination
		  pagination: {
		    el: el.querySelector('.swiper-pagination'),
		    type: 'bullets',
		  },
		  // Navigation arrows
		  navigation: {
		    nextEl: el.querySelector('.swiper-button-next'),
		    prevEl: el.querySelector('.swiper-button-prev'),
		  },
	  });

	});


}